import React from 'react';
import { Dialog } from 'evergreen-ui';
import { OrderImportPage } from '../pages';

/**
 * Modal component for the order import page
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isShown - Whether the modal is shown
 * @param {Function} props.onClose - Function to call when the modal is closed
 */
const OrderImportModal = ({ isShown, onClose }) => {
  return (
    <Dialog
      isShown={isShown}
      title="Advanced CSV Import"
      onCloseComplete={onClose}
      hasFooter={false}
      width="90%"
      height="90%"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEscapePress={false}
      preventBodyScrolling
    >
      <OrderImportPage onClose={onClose} />
    </Dialog>
  );
};

export default OrderImportModal;
